"use strict";
angular.module('appMarketplace')
    .controller('AccountCtrl', ['$scope', '$location', 'NavigationService', function ($scope, $location, NavigationService) {
        function updateSkipLink() {
            var currentUrl = $location.absUrl();
            var hash = $location.hash();
            if (hash) {
                currentUrl = currentUrl.replace("#" + hash, "");
            }
            $scope.skipLink = currentUrl + "#main-content";
        }

        updateSkipLink();

        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
            $scope.currentAccount = currentAccount;
        });
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/account-ctrl.js
// module id = 203
// module chunks = 17